export default "__VITE_ASSET__lRcvu1Mt__"